import { render, staticRenderFns } from "./ColorBlocks.vue?vue&type=template&id=512dcbb6&scoped=true&"
import script from "./ColorBlocks.vue?vue&type=script&lang=js&"
export * from "./ColorBlocks.vue?vue&type=script&lang=js&"
import style0 from "./ColorBlocks.vue?vue&type=style&index=0&id=512dcbb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512dcbb6",
  null
  
)

export default component.exports